// ═══════════════════════════════════════════════════════════════════════════
// Migraciones de forma de los datos — extraídas VERBATIM de v0.9.16.
// Rellenan campos que versiones viejas no guardaban.
// ═══════════════════════════════════════════════════════════════════════════

export function migrateProducts(prods) {
  if (!prods || !Array.isArray(prods)) return prods;
  let migrated = prods.map(p => {
    let m = { ...p };
    if (m.basePrice !== undefined && m.basePrice > 0 && !m.grossPrice) {
      m.grossPrice = m.basePrice;
    }
    if (m.netPrice !== undefined && !m.grossPrice && m.category !== "cortesia") {
      m.grossPrice = m.netPrice;
    }
    if (m.stock === undefined) m.stock = 0;
    if (!m.description) m.description = "";
    if (!m.tastingNotes) m.tastingNotes = "";
    if (!m.imageBase64) m.imageBase64 = "";
    return m;
  });
  if (!migrated.find(p => p.category === "cortesia")) {
    migrated.push({ id: "p_cortesia", name: "Botellas de cortesía", grossPrice: 0, netPrice: 0, category: "cortesia", gl: 0, iepsRate: 0, stock: 0, description: "", tastingNotes: "", imageBase64: "" });
  }
  return migrated;
}

export function migrateInvoices(invs) {
  if (!invs || !Array.isArray(invs)) return invs || [];
  return invs.map(inv => {
    let m = { ...inv };
    // Ensure every invoice has an id
    if (!m.id) m.id = "inv_" + (m.folio || "") + "_" + Math.random().toString(36).substr(2, 6);
    // Ensure client object
    if (!m.client) m.client = { name: "Desconocido", id: "unknown" };
    if (!m.client.id) m.client.id = "c_" + (m.client.name || "").replace(/\s+/g, "_").toLowerCase().substr(0, 20) + "_" + Math.random().toString(36).substr(2, 4);
    return m;
  });
}
